import { render, staticRenderFns } from "./ReservationList.vue?vue&type=template&id=31f47db4&scoped=true"
import script from "./ReservationList.vue?vue&type=script&lang=ts"
export * from "./ReservationList.vue?vue&type=script&lang=ts"
import style0 from "./ReservationList.vue?vue&type=style&index=0&id=31f47db4&prod&lang=sass&scoped=true"
import style1 from "./ReservationList.vue?vue&type=style&index=1&id=31f47db4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f47db4",
  null
  
)

export default component.exports